/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { account_category_AccountCategorySchemaItems } from '../models/account_category_AccountCategorySchemaItems';
import type { account_details_AccountDetails } from '../models/account_details_AccountDetails';
import type { allocation_report_WeightedAllocationReport } from '../models/allocation_report_WeightedAllocationReport';
import type { app_v1_account_AccountCreate } from '../models/app_v1_account_AccountCreate';
import type { app_v1_account_AccountHistoricalValue } from '../models/app_v1_account_AccountHistoricalValue';
import type { app_v1_account_AccountsSummary } from '../models/app_v1_account_AccountsSummary';
import type { app_v1_account_AccountUpdate } from '../models/app_v1_account_AccountUpdate';
import type { app_v1_account_ExternalAssetsAccountRequest } from '../models/app_v1_account_ExternalAssetsAccountRequest';
import type { app_v1_analytics_AnalyticsAllocation } from '../models/app_v1_analytics_AnalyticsAllocation';
import type { app_v1_analytics_AnalyticsSummary } from '../models/app_v1_analytics_AnalyticsSummary';
import type { app_v1_auth_AppleLogin } from '../models/app_v1_auth_AppleLogin';
import type { app_v1_auth_AppleRegister } from '../models/app_v1_auth_AppleRegister';
import type { app_v1_auth_BankIDStart } from '../models/app_v1_auth_BankIDStart';
import type { app_v1_auth_BankIDStatus } from '../models/app_v1_auth_BankIDStatus';
import type { app_v1_auth_GoogleLogin } from '../models/app_v1_auth_GoogleLogin';
import type { app_v1_auth_GoogleRegister } from '../models/app_v1_auth_GoogleRegister';
import type { app_v1_auth_Login } from '../models/app_v1_auth_Login';
import type { app_v1_auth_OauthRegisterResponse } from '../models/app_v1_auth_OauthRegisterResponse';
import type { app_v1_auth_Register } from '../models/app_v1_auth_Register';
import type { app_v1_auth_TokenResponse } from '../models/app_v1_auth_TokenResponse';
import type { app_v1_auth_User } from '../models/app_v1_auth_User';
import type { app_v1_auth_UserUpdate } from '../models/app_v1_auth_UserUpdate';
import type { app_v1_auth_VerifyTokenResponse } from '../models/app_v1_auth_VerifyTokenResponse';
import type { app_v1_chat_AddChatMessage } from '../models/app_v1_chat_AddChatMessage';
import type { app_v1_chat_AvailableModelSchemaItems } from '../models/app_v1_chat_AvailableModelSchemaItems';
import type { app_v1_chat_ChatBase } from '../models/app_v1_chat_ChatBase';
import type { app_v1_chat_ChatRead } from '../models/app_v1_chat_ChatRead';
import type { app_v1_chat_ChatReadSchemaItems } from '../models/app_v1_chat_ChatReadSchemaItems';
import type { app_v1_chat_FileUrl } from '../models/app_v1_chat_FileUrl';
import type { app_v1_chat_PatchChat } from '../models/app_v1_chat_PatchChat';
import type { app_v1_chat_ReadPrompt } from '../models/app_v1_chat_ReadPrompt';
import type { app_v1_chat_ToolSchemaItems } from '../models/app_v1_chat_ToolSchemaItems';
import type { app_v1_connections_RefreshUrl } from '../models/app_v1_connections_RefreshUrl';
import type { app_v1_external_assets_CreateExternalAsset } from '../models/app_v1_external_assets_CreateExternalAsset';
import type { app_v1_external_assets_ExternalAsset } from '../models/app_v1_external_assets_ExternalAsset';
import type { app_v1_external_assets_ExternalAssetHistory } from '../models/app_v1_external_assets_ExternalAssetHistory';
import type { app_v1_external_assets_ExternalAssetSchemaItems } from '../models/app_v1_external_assets_ExternalAssetSchemaItems';
import type { app_v1_external_assets_UpdateExternalAssetTrade } from '../models/app_v1_external_assets_UpdateExternalAssetTrade';
import type { app_v1_goal_template_GoalTemplateSchemaItems } from '../models/app_v1_goal_template_GoalTemplateSchemaItems';
import type { app_v1_holdings_HoldingsCollectionCreate } from '../models/app_v1_holdings_HoldingsCollectionCreate';
import type { app_v1_holdings_HoldingsCollectionCreateResult } from '../models/app_v1_holdings_HoldingsCollectionCreateResult';
import type { app_v1_insights_InsightResponse } from '../models/app_v1_insights_InsightResponse';
import type { app_v1_instruments_InstrumentsPriceResponse } from '../models/app_v1_instruments_InstrumentsPriceResponse';
import type { app_v1_monitor_template_MonitorTemplateSchemaItems } from '../models/app_v1_monitor_template_MonitorTemplateSchemaItems';
import type { app_v1_positions_AccountPositionRequest } from '../models/app_v1_positions_AccountPositionRequest';
import type { app_v1_positions_Position } from '../models/app_v1_positions_Position';
import type { app_v1_positions_Positions } from '../models/app_v1_positions_Positions';
import type { app_v1_positions_PositionsCreate } from '../models/app_v1_positions_PositionsCreate';
import type { app_v1_prompt_manager_OverrideBasePrompt } from '../models/app_v1_prompt_manager_OverrideBasePrompt';
import type { app_v1_settings_AppSettings } from '../models/app_v1_settings_AppSettings';
import type { app_v1_settings_UserSettings } from '../models/app_v1_settings_UserSettings';
import type { connections_DataConnection } from '../models/connections_DataConnection';
import type { connections_DataConnectionSchemaItems } from '../models/connections_DataConnectionSchemaItems';
import type { core_ReportColumn } from '../models/core_ReportColumn';
import type { email_verification_EmailVerification } from '../models/email_verification_EmailVerification';
import type { events_EventSchemaItems } from '../models/events_EventSchemaItems';
import type { instrument_PaginatedInstrumentsSearch } from '../models/instrument_PaginatedInstrumentsSearch';
import type { llm_chat_StreamResponse } from '../models/llm_chat_StreamResponse';
import type { loans_report_Loans } from '../models/loans_report_Loans';
import type { market_value_MarketValueChange } from '../models/market_value_MarketValueChange';
import type { market_value_MarketValueHistoryReport } from '../models/market_value_MarketValueHistoryReport';
import type { monitor_BaseMonitor } from '../models/monitor_BaseMonitor';
import type { monitor_BaseMonitorSchemaItems } from '../models/monitor_BaseMonitorSchemaItems';
import type { monitor_BaseMonitorSchemaItems1 } from '../models/monitor_BaseMonitorSchemaItems1';
import type { monitor_MonitorCreate } from '../models/monitor_MonitorCreate';
import type { monitor_MonitorPatch } from '../models/monitor_MonitorPatch';
import type { portfolio_benchmark_PortfolioBenchmarkSchemaItems } from '../models/portfolio_benchmark_PortfolioBenchmarkSchemaItems';
import type { portfolio_benchmark_PortfoliosBenchmarkResult } from '../models/portfolio_benchmark_PortfoliosBenchmarkResult';
import type { positions_report_PositionsInput } from '../models/positions_report_PositionsInput';
import type { profit_and_loss_ProfitAndLossReport } from '../models/profit_and_loss_ProfitAndLossReport';
import type { recovery_ResetPassword } from '../models/recovery_ResetPassword';
import type { recovery_SendResetPasswordEmail } from '../models/recovery_SendResetPasswordEmail';
import type { recovery_SendResetPasswordEmailOrg } from '../models/recovery_SendResetPasswordEmailOrg';
import type { summary_report_AccountSummary } from '../models/summary_report_AccountSummary';
import type { summary_report_ClientSummary } from '../models/summary_report_ClientSummary';
import type { summary_report_PositionSummary } from '../models/summary_report_PositionSummary';
import type { system_status_SystemStatusEventsBodySchemaItems } from '../models/system_status_SystemStatusEventsBodySchemaItems';
import type { user_goal_UserGoal } from '../models/user_goal_UserGoal';
import type { user_goal_UserGoalCreate } from '../models/user_goal_UserGoalCreate';
import type { user_goal_UserGoalSchemaItems } from '../models/user_goal_UserGoalSchemaItems';
import type { user_goal_UserGoalUpdate } from '../models/user_goal_UserGoalUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DefaultService {

    /**
     * /app/v1/accounts
     * @returns app_v1_account_AccountsSummary
     * @throws ApiError
     */
    public static getAppV1Accounts(): CancelablePromise<app_v1_account_AccountsSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/accounts',
        });
    }

    /**
     * /app/v1/accounts
     * @param requestBody
     * @returns account_details_AccountDetails
     * @throws ApiError
     */
    public static postAppV1Accounts(
        requestBody?: app_v1_account_AccountCreate,
    ): CancelablePromise<account_details_AccountDetails> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/accounts',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/accounts/categories
     * @returns account_category_AccountCategorySchemaItems
     * @throws ApiError
     */
    public static getAppV1AccountsCategories(): CancelablePromise<account_category_AccountCategorySchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/accounts/categories',
        });
    }

    /**
     * /app/v1/accounts/loans/summary
     * Returns holdings loans report for the specified user_id
     * @returns loans_report_Loans
     * @throws ApiError
     */
    public static getAppV1AccountsLoansSummary(): CancelablePromise<loans_report_Loans> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/accounts/loans/summary',
        });
    }

    /**
     * /app/v1/accounts/<account_id>
     * @param accountId
     * @param requestBody
     * @returns account_details_AccountDetails
     * @throws ApiError
     */
    public static deleteAppV1Accounts(
        accountId: string,
        requestBody?: account_details_AccountDetails,
    ): CancelablePromise<account_details_AccountDetails> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/app/v1/accounts/{account_id}',
            path: {
                'account_id': accountId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/accounts/<account_id>
     * @param accountId
     * @returns account_details_AccountDetails
     * @throws ApiError
     */
    public static getAppV1Accounts1(
        accountId: string,
    ): CancelablePromise<account_details_AccountDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/accounts/{account_id}',
            path: {
                'account_id': accountId,
            },
        });
    }

    /**
     * /app/v1/accounts/<account_id>
     * @param accountId
     * @param requestBody
     * @returns account_details_AccountDetails
     * @throws ApiError
     */
    public static patchAppV1Accounts(
        accountId: string,
        requestBody?: app_v1_account_AccountUpdate,
    ): CancelablePromise<account_details_AccountDetails> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/accounts/{account_id}',
            path: {
                'account_id': accountId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/accounts/<account_id>
     * @param accountId
     * @param requestBody
     * @returns account_details_AccountDetails
     * @throws ApiError
     */
    public static putAppV1Accounts(
        accountId: string,
        requestBody?: app_v1_account_AccountUpdate,
    ): CancelablePromise<account_details_AccountDetails> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/app/v1/accounts/{account_id}',
            path: {
                'account_id': accountId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/accounts/<account_id>/external-assets
     * Get all external assets for the account.
     * @param accountId
     * @returns app_v1_external_assets_ExternalAssetSchemaItems
     * @throws ApiError
     */
    public static getAppV1AccountsExternalAssets(
        accountId: string,
    ): CancelablePromise<app_v1_external_assets_ExternalAssetSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/accounts/{account_id}/external-assets',
            path: {
                'account_id': accountId,
            },
        });
    }

    /**
     * /app/v1/accounts/<account_id>/external-assets
     * Create a new external asset.
     * @param accountId
     * @param requestBody
     * @returns app_v1_external_assets_ExternalAsset
     * @throws ApiError
     */
    public static postAppV1AccountsExternalAssets(
        accountId: string,
        requestBody?: app_v1_external_assets_CreateExternalAsset,
    ): CancelablePromise<app_v1_external_assets_ExternalAsset> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/accounts/{account_id}/external-assets',
            path: {
                'account_id': accountId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/accounts/<account_id>/historical-value
     *
     * Returns historical account value combining cash balance and securities value
     *
     * @param accountId
     * @param endDate
     * @param startDate
     * @returns app_v1_account_AccountHistoricalValue
     * @throws ApiError
     */
    public static getAppV1AccountsHistoricalValue(
        accountId: string,
        endDate: string,
        startDate: string,
    ): CancelablePromise<app_v1_account_AccountHistoricalValue> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/accounts/{account_id}/historical-value',
            path: {
                'account_id': accountId,
            },
            query: {
                'end_date': endDate,
                'start_date': startDate,
            },
        });
    }

    /**
     * /app/v1/accounts/<account_id>/interest
     * @param accountId
     * @throws ApiError
     */
    public static getAppV1AccountsInterest(
        accountId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/accounts/{account_id}/interest',
            path: {
                'account_id': accountId,
            },
        });
    }

    /**
     * /app/v1/accounts/<account_id>/interest
     * @param accountId
     * @param interest
     * @throws ApiError
     */
    public static patchAppV1AccountsInterest(
        accountId: string,
        interest: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/accounts/{account_id}/interest',
            path: {
                'account_id': accountId,
            },
            query: {
                'interest': interest,
            },
        });
    }

    /**
     * /app/v1/accounts/<account_id>/interest
     * @param accountId
     * @param interest
     * @throws ApiError
     */
    public static putAppV1AccountsInterest(
        accountId: string,
        interest: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/app/v1/accounts/{account_id}/interest',
            path: {
                'account_id': accountId,
            },
            query: {
                'interest': interest,
            },
        });
    }

    /**
     * /app/v1/accounts/<account_id>/market-value-projection
     *
     * Returns projected value of the current shares over a period of time
     *
     * @param accountId
     * @param endDate
     * @param startDate
     * @returns app_v1_account_AccountHistoricalValue
     * @throws ApiError
     */
    public static getAppV1AccountsMarketValueProjection(
        accountId: string,
        endDate: string,
        startDate: string,
    ): CancelablePromise<app_v1_account_AccountHistoricalValue> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/accounts/{account_id}/market-value-projection',
            path: {
                'account_id': accountId,
            },
            query: {
                'end_date': endDate,
                'start_date': startDate,
            },
        });
    }

    /**
     * /app/v1/accounts/<account_id>/position/summary
     * @param accountId
     * @param endDate
     * @param startDate
     * @param ticker Ticker for the security. For cash positions use CASH.SEK.
     * @returns summary_report_PositionSummary
     * @throws ApiError
     */
    public static getAppV1AccountsPositionSummary(
        accountId: string,
        endDate: string,
        startDate: string,
        ticker: string,
    ): CancelablePromise<summary_report_PositionSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/accounts/{account_id}/position/summary',
            path: {
                'account_id': accountId,
            },
            query: {
                'end_date': endDate,
                'start_date': startDate,
                'ticker': ticker,
            },
        });
    }

    /**
     * /app/v1/accounts/<account_id>/positions/<ticker>
     * This position goes to 0 (update to 0 by creating negative trade)
     * @param accountId
     * @param ticker
     * @throws ApiError
     */
    public static deleteAppV1AccountsPositions(
        accountId: string,
        ticker: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/app/v1/accounts/{account_id}/positions/{ticker}',
            path: {
                'account_id': accountId,
                'ticker': ticker,
            },
        });
    }

    /**
     * /app/v1/accounts/<account_id>/positions/<ticker>
     * From the updated positions, create a new trade
     * @param accountId
     * @param ticker
     * @param requestBody
     * @throws ApiError
     */
    public static patchAppV1AccountsPositions(
        accountId: string,
        ticker: string,
        requestBody?: app_v1_positions_AccountPositionRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/accounts/{account_id}/positions/{ticker}',
            path: {
                'account_id': accountId,
                'ticker': ticker,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/accounts/<account_id>/positions/<ticker>
     * Create a new trade (add to position)
     * @param accountId
     * @param ticker
     * @param requestBody
     * @returns app_v1_positions_Position
     * @throws ApiError
     */
    public static postAppV1AccountsPositions(
        accountId: string,
        ticker: string,
        requestBody?: app_v1_positions_AccountPositionRequest,
    ): CancelablePromise<app_v1_positions_Position> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/accounts/{account_id}/positions/{ticker}',
            path: {
                'account_id': accountId,
                'ticker': ticker,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/accounts/<account_id>/positions/<ticker>
     * From the updated positions, create a new trade
     * @param accountId
     * @param ticker
     * @param requestBody
     * @throws ApiError
     */
    public static putAppV1AccountsPositions(
        accountId: string,
        ticker: string,
        requestBody?: app_v1_positions_AccountPositionRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/app/v1/accounts/{account_id}/positions/{ticker}',
            path: {
                'account_id': accountId,
                'ticker': ticker,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/accounts/<account_id>/summary
     * @param accountId
     * @param endDate
     * @param startDate
     * @param acceptLanguage
     * @returns summary_report_AccountSummary
     * @throws ApiError
     */
    public static getAppV1AccountsSummary(
        accountId: string,
        endDate: string,
        startDate: string,
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<summary_report_AccountSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/accounts/{account_id}/summary',
            path: {
                'account_id': accountId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'end_date': endDate,
                'start_date': startDate,
            },
        });
    }

    /**
     * /app/v1/analytics/allocations
     * @param acceptLanguage
     * @param includeCash
     * @returns app_v1_analytics_AnalyticsAllocation
     * @throws ApiError
     */
    public static getAppV1AnalyticsAllocations(
        acceptLanguage?: 'en' | 'sv',
        includeCash: boolean = false,
    ): CancelablePromise<app_v1_analytics_AnalyticsAllocation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/analytics/allocations',
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'include_cash': includeCash,
            },
        });
    }

    /**
     * /app/v1/analytics/summary
     * @param includeCash
     * @returns app_v1_analytics_AnalyticsSummary
     * @throws ApiError
     */
    public static getAppV1AnalyticsSummary(
        includeCash: boolean = false,
    ): CancelablePromise<app_v1_analytics_AnalyticsSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/analytics/summary',
            query: {
                'include_cash': includeCash,
            },
        });
    }

    /**
     * /app/v1/auth/bank-id/start
     * @param requestBody
     * @returns app_v1_auth_BankIDStart
     * @throws ApiError
     */
    public static postAppV1AuthBankIdStart(
        requestBody?: app_v1_auth_BankIDStart,
    ): CancelablePromise<app_v1_auth_BankIDStart> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/auth/bank-id/start',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/auth/bank-id/status
     * @param requestBody
     * @returns app_v1_auth_BankIDStatus
     * @throws ApiError
     */
    public static postAppV1AuthBankIdStatus(
        requestBody?: app_v1_auth_BankIDStatus,
    ): CancelablePromise<app_v1_auth_BankIDStatus> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/auth/bank-id/status',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/auth/login
     * @param requestBody
     * @throws ApiError
     */
    public static postAppV1AuthLogin(
        requestBody?: app_v1_auth_Login,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/auth/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/auth/login/apple
     * @param requestBody
     * @throws ApiError
     */
    public static postAppV1AuthLoginApple(
        requestBody?: app_v1_auth_AppleLogin,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/auth/login/apple',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/auth/login/google
     * @param njordaClient
     * @param requestBody
     * @throws ApiError
     */
    public static postAppV1AuthLoginGoogle(
        njordaClient?: 'web' | 'ios' | 'android',
        requestBody?: app_v1_auth_GoogleLogin,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/auth/login/google',
            headers: {
                'Njorda-Client': njordaClient,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/auth/logout
     * @throws ApiError
     */
    public static postAppV1AuthLogout(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/auth/logout',
        });
    }

    /**
     * /app/v1/auth/me
     * @throws ApiError
     */
    public static deleteAppV1AuthMe(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/app/v1/auth/me',
        });
    }

    /**
     * /app/v1/auth/me
     * @returns app_v1_auth_User
     * @throws ApiError
     */
    public static getAppV1AuthMe(): CancelablePromise<app_v1_auth_User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/auth/me',
        });
    }

    /**
     * /app/v1/auth/me
     * @param requestBody
     * @returns app_v1_auth_User
     * @throws ApiError
     */
    public static patchAppV1AuthMe(
        requestBody?: app_v1_auth_UserUpdate,
    ): CancelablePromise<app_v1_auth_User> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/auth/me',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/auth/me
     * @param requestBody
     * @returns app_v1_auth_User
     * @throws ApiError
     */
    public static putAppV1AuthMe(
        requestBody?: app_v1_auth_UserUpdate,
    ): CancelablePromise<app_v1_auth_User> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/app/v1/auth/me',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/auth/register
     * @param requestBody
     * @throws ApiError
     */
    public static postAppV1AuthRegister(
        requestBody?: app_v1_auth_Register,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/auth/register',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/auth/register/apple
     * @param requestBody
     * @returns app_v1_auth_OauthRegisterResponse
     * @throws ApiError
     */
    public static postAppV1AuthRegisterApple(
        requestBody?: app_v1_auth_AppleRegister,
    ): CancelablePromise<app_v1_auth_OauthRegisterResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/auth/register/apple',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/auth/register/google
     * @param njordaClient
     * @param requestBody
     * @returns app_v1_auth_OauthRegisterResponse
     * @throws ApiError
     */
    public static postAppV1AuthRegisterGoogle(
        njordaClient?: 'web' | 'ios' | 'android',
        requestBody?: app_v1_auth_GoogleRegister,
    ): CancelablePromise<app_v1_auth_OauthRegisterResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/auth/register/google',
            headers: {
                'Njorda-Client': njordaClient,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/auth/sse-token
     * @returns app_v1_auth_TokenResponse
     * @throws ApiError
     */
    public static getAppV1AuthSseToken(): CancelablePromise<app_v1_auth_TokenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/auth/sse-token',
        });
    }

    /**
     * /app/v1/auth/verify-token
     * @returns app_v1_auth_VerifyTokenResponse
     * @throws ApiError
     */
    public static getAppV1AuthVerifyToken(): CancelablePromise<app_v1_auth_VerifyTokenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/auth/verify-token',
        });
    }

    /**
     * /app/v1/calculate/allocations/accounts/<account_id>
     * @param accountId
     * @param acceptLanguage
     * @returns allocation_report_WeightedAllocationReport
     * @throws ApiError
     */
    public static postAppV1CalculateAllocationsAccounts(
        accountId: string,
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<allocation_report_WeightedAllocationReport> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/calculate/allocations/accounts/{account_id}',
            path: {
                'account_id': accountId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
        });
    }

    /**
     * /app/v1/calculate/allocations/positions
     * @param acceptLanguage
     * @param requestBody
     * @returns allocation_report_WeightedAllocationReport
     * @throws ApiError
     */
    public static postAppV1CalculateAllocationsPositions(
        acceptLanguage?: 'en' | 'sv',
        requestBody?: positions_report_PositionsInput,
    ): CancelablePromise<allocation_report_WeightedAllocationReport> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/calculate/allocations/positions',
            headers: {
                'Accept-Language': acceptLanguage,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/calculate/portfolio-benchmark
     * @param portfolioBenchmarkIds
     * @returns portfolio_benchmark_PortfoliosBenchmarkResult
     * @throws ApiError
     */
    public static getAppV1CalculatePortfolioBenchmark(
        portfolioBenchmarkIds: string,
    ): CancelablePromise<portfolio_benchmark_PortfoliosBenchmarkResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/calculate/portfolio-benchmark',
            query: {
                'portfolio_benchmark_ids': portfolioBenchmarkIds,
            },
        });
    }

    /**
     * /app/v1/callback/flanks
     * @param code
     * @throws ApiError
     */
    public static getAppV1CallbackFlanks(
        code: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/callback/flanks',
            query: {
                'code': code,
            },
        });
    }

    /**
     * /app/v1/chats
     * @returns app_v1_chat_ChatReadSchemaItems
     * @throws ApiError
     */
    public static getAppV1Chats(): CancelablePromise<app_v1_chat_ChatReadSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/chats',
        });
    }

    /**
     * /app/v1/chats
     * @param requestBody
     * @returns app_v1_chat_ChatRead
     * @throws ApiError
     */
    public static postAppV1Chats(
        requestBody?: app_v1_chat_ChatBase,
    ): CancelablePromise<app_v1_chat_ChatRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/chats',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/chats/available-models
     * @returns app_v1_chat_AvailableModelSchemaItems
     * @throws ApiError
     */
    public static getAppV1ChatsAvailableModels(): CancelablePromise<app_v1_chat_AvailableModelSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/chats/available-models',
        });
    }

    /**
     * /app/v1/chats/available-tools
     * @param llmModelName
     * @returns app_v1_chat_ToolSchemaItems
     * @throws ApiError
     */
    public static getAppV1ChatsAvailableTools(
        llmModelName?: string,
    ): CancelablePromise<app_v1_chat_ToolSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/chats/available-tools',
            query: {
                'llm_model_name': llmModelName,
            },
        });
    }

    /**
     * /app/v1/chats/base-prompt
     * @returns app_v1_chat_ReadPrompt
     * @throws ApiError
     */
    public static getAppV1ChatsBasePrompt(): CancelablePromise<app_v1_chat_ReadPrompt> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/chats/base-prompt',
        });
    }

    /**
     * /app/v1/chats/latest
     * @returns app_v1_chat_ChatRead
     * @throws ApiError
     */
    public static getAppV1ChatsLatest(): CancelablePromise<app_v1_chat_ChatRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/chats/latest',
        });
    }

    /**
     * /app/v1/chats/pre-signed-url
     * @param requestBody
     * @returns app_v1_chat_FileUrl
     * @throws ApiError
     */
    public static postAppV1ChatsPreSignedUrl(
        requestBody?: app_v1_chat_FileUrl,
    ): CancelablePromise<app_v1_chat_FileUrl> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/chats/pre-signed-url',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/chats/<chat_id>
     * @param chatId
     * @throws ApiError
     */
    public static deleteAppV1Chats(
        chatId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/app/v1/chats/{chat_id}',
            path: {
                'chat_id': chatId,
            },
        });
    }

    /**
     * /app/v1/chats/<chat_id>
     * @param chatId
     * @returns app_v1_chat_ChatRead
     * @throws ApiError
     */
    public static getAppV1Chats1(
        chatId: string,
    ): CancelablePromise<app_v1_chat_ChatRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/chats/{chat_id}',
            path: {
                'chat_id': chatId,
            },
        });
    }

    /**
     * /app/v1/chats/<chat_id>
     * @param chatId
     * @param requestBody
     * @returns app_v1_chat_ChatRead
     * @throws ApiError
     */
    public static patchAppV1Chats(
        chatId: string,
        requestBody?: app_v1_chat_PatchChat,
    ): CancelablePromise<app_v1_chat_ChatRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/chats/{chat_id}',
            path: {
                'chat_id': chatId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/chats/<chat_id>/stream
     * @param chatId
     * @param requestBody
     * @returns llm_chat_StreamResponse
     * @throws ApiError
     */
    public static patchAppV1ChatsStream(
        chatId: string,
        requestBody?: app_v1_chat_AddChatMessage,
    ): CancelablePromise<llm_chat_StreamResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/chats/{chat_id}/stream',
            path: {
                'chat_id': chatId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/connections
     * @returns connections_DataConnectionSchemaItems
     * @throws ApiError
     */
    public static getAppV1Connections(): CancelablePromise<connections_DataConnectionSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/connections',
        });
    }

    /**
     * /app/v1/connections/<data_connection_id>
     * @param dataConnectionId
     * @throws ApiError
     */
    public static deleteAppV1Connections(
        dataConnectionId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/app/v1/connections/{data_connection_id}',
            path: {
                'data_connection_id': dataConnectionId,
            },
        });
    }

    /**
     * /app/v1/connections/<data_connection_id>
     * @param dataConnectionId
     * @returns connections_DataConnection
     * @throws ApiError
     */
    public static getAppV1Connections1(
        dataConnectionId: string,
    ): CancelablePromise<connections_DataConnection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/connections/{data_connection_id}',
            path: {
                'data_connection_id': dataConnectionId,
            },
        });
    }

    /**
     * /app/v1/connections/<data_connection_id>/refresh
     * @param dataConnectionId
     * @param requestBody
     * @returns app_v1_connections_RefreshUrl
     * @throws ApiError
     */
    public static postAppV1ConnectionsRefresh(
        dataConnectionId: string,
        requestBody?: app_v1_connections_RefreshUrl,
    ): CancelablePromise<app_v1_connections_RefreshUrl> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/connections/{data_connection_id}/refresh',
            path: {
                'data_connection_id': dataConnectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/docs
     * @throws ApiError
     */
    public static getAppV1Docs(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/docs',
        });
    }

    /**
     * /app/v1/email-verification/send
     * @throws ApiError
     */
    public static postAppV1EmailVerificationSend(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/email-verification/send',
        });
    }

    /**
     * /app/v1/email-verification/verify
     * @param requestBody
     * @throws ApiError
     */
    public static postAppV1EmailVerificationVerify(
        requestBody?: email_verification_EmailVerification,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/email-verification/verify',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/events/stream
     * @throws ApiError
     */
    public static getAppV1EventsStream(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/events/stream',
        });
    }

    /**
     * /app/v1/events/<channel>
     * @param channel
     * @param sinceTimestamp
     * @returns events_EventSchemaItems
     * @throws ApiError
     */
    public static getAppV1Events(
        channel: string,
        sinceTimestamp: string,
    ): CancelablePromise<events_EventSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/events/{channel}',
            path: {
                'channel': channel,
            },
            query: {
                'since_timestamp': sinceTimestamp,
            },
        });
    }

    /**
     * /app/v1/external-assets/account
     * @param requestBody
     * @returns account_details_AccountDetails
     * @throws ApiError
     */
    public static postAppV1ExternalAssetsAccount(
        requestBody?: app_v1_account_ExternalAssetsAccountRequest,
    ): CancelablePromise<account_details_AccountDetails> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/external-assets/account',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/external-assets/<asset_id>
     * @param assetId
     * @param requestBody
     * @returns app_v1_external_assets_ExternalAsset
     * @throws ApiError
     */
    public static deleteAppV1ExternalAssets(
        assetId: string,
        requestBody?: app_v1_external_assets_ExternalAsset,
    ): CancelablePromise<app_v1_external_assets_ExternalAsset> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/app/v1/external-assets/{asset_id}',
            path: {
                'asset_id': assetId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/external-assets/<asset_id>
     * @param assetId
     * @returns app_v1_external_assets_ExternalAsset
     * @throws ApiError
     */
    public static getAppV1ExternalAssets(
        assetId: string,
    ): CancelablePromise<app_v1_external_assets_ExternalAsset> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/external-assets/{asset_id}',
            path: {
                'asset_id': assetId,
            },
        });
    }

    /**
     * /app/v1/external-assets/<asset_id>
     * @param assetId
     * @param requestBody
     * @returns app_v1_external_assets_ExternalAsset
     * @throws ApiError
     */
    public static patchAppV1ExternalAssets(
        assetId: string,
        requestBody?: app_v1_external_assets_UpdateExternalAssetTrade,
    ): CancelablePromise<app_v1_external_assets_ExternalAsset> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/external-assets/{asset_id}',
            path: {
                'asset_id': assetId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/external-assets/<asset_id>
     * @param assetId
     * @param requestBody
     * @returns app_v1_external_assets_ExternalAsset
     * @throws ApiError
     */
    public static putAppV1ExternalAssets(
        assetId: string,
        requestBody?: app_v1_external_assets_UpdateExternalAssetTrade,
    ): CancelablePromise<app_v1_external_assets_ExternalAsset> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/app/v1/external-assets/{asset_id}',
            path: {
                'asset_id': assetId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/external-assets/<asset_id>/history
     * @param assetId
     * @returns app_v1_external_assets_ExternalAssetHistory
     * @throws ApiError
     */
    public static getAppV1ExternalAssetsHistory(
        assetId: string,
    ): CancelablePromise<app_v1_external_assets_ExternalAssetHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/external-assets/{asset_id}/history',
            path: {
                'asset_id': assetId,
            },
        });
    }

    /**
     * /app/v1/goal-templates
     * @returns app_v1_goal_template_GoalTemplateSchemaItems
     * @throws ApiError
     */
    public static getAppV1GoalTemplates(): CancelablePromise<app_v1_goal_template_GoalTemplateSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/goal-templates',
        });
    }

    /**
     * /app/v1/holdings/collect/start
     * Create data session for the specified user_id
     * @param requestBody
     * @returns app_v1_holdings_HoldingsCollectionCreateResult
     * @throws ApiError
     */
    public static postAppV1HoldingsCollectStart(
        requestBody?: app_v1_holdings_HoldingsCollectionCreate,
    ): CancelablePromise<app_v1_holdings_HoldingsCollectionCreateResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/holdings/collect/start',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/insights/refresh
     * @throws ApiError
     */
    public static postAppV1InsightsRefresh(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/insights/refresh',
        });
    }

    /**
     * /app/v1/insights/summary
     * @returns app_v1_insights_InsightResponse
     * @throws ApiError
     */
    public static getAppV1InsightsSummary(): CancelablePromise<app_v1_insights_InsightResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/insights/summary',
        });
    }

    /**
     * /app/v1/insights/summary
     * @param requestBody
     * @returns app_v1_insights_InsightResponse
     * @throws ApiError
     */
    public static postAppV1InsightsSummary(
        requestBody?: app_v1_chat_ChatBase,
    ): CancelablePromise<app_v1_insights_InsightResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/insights/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/instruments/prices
     * @param baseCurrency
     * @param tickers
     * @returns app_v1_instruments_InstrumentsPriceResponse
     * @throws ApiError
     */
    public static getAppV1InstrumentsPrices(
        baseCurrency: 'USD' | 'EUR' | 'SEK' | 'BRL' | 'GBP' | 'GBX',
        tickers: string,
    ): CancelablePromise<app_v1_instruments_InstrumentsPriceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/instruments/prices',
            query: {
                'base_currency': baseCurrency,
                'tickers': tickers,
            },
        });
    }

    /**
     * /app/v1/instruments/search
     * @param q
     * @param page
     * @param types
     * @returns instrument_PaginatedInstrumentsSearch
     * @throws ApiError
     */
    public static getAppV1InstrumentsSearch(
        q: string,
        page?: number,
        types?: string,
    ): CancelablePromise<instrument_PaginatedInstrumentsSearch> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/instruments/search',
            query: {
                'page': page,
                'q': q,
                'types': types,
            },
        });
    }

    /**
     * /app/v1/market-value/change
     * @returns market_value_MarketValueChange
     * @throws ApiError
     */
    public static getAppV1MarketValueChange(): CancelablePromise<market_value_MarketValueChange> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/market-value/change',
        });
    }

    /**
     * /app/v1/market-value/history
     * @param daysBack
     * @returns market_value_MarketValueHistoryReport
     * @throws ApiError
     */
    public static getAppV1MarketValueHistory(
        daysBack: number,
    ): CancelablePromise<market_value_MarketValueHistoryReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/market-value/history',
            query: {
                'days_back': daysBack,
            },
        });
    }

    /**
     * /app/v1/monitor-templates
     * @returns app_v1_monitor_template_MonitorTemplateSchemaItems
     * @throws ApiError
     */
    public static getAppV1MonitorTemplates(): CancelablePromise<app_v1_monitor_template_MonitorTemplateSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/monitor-templates',
        });
    }

    /**
     * /app/v1/monitors
     * @returns monitor_BaseMonitorSchemaItems1
     * @throws ApiError
     */
    public static getAppV1Monitors(): CancelablePromise<monitor_BaseMonitorSchemaItems1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/monitors',
        });
    }

    /**
     * /app/v1/monitors
     * @param requestBody
     * @returns monitor_BaseMonitor
     * @throws ApiError
     */
    public static postAppV1Monitors(
        requestBody?: monitor_MonitorCreate,
    ): CancelablePromise<monitor_BaseMonitor> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/monitors',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/monitors/check
     * @returns monitor_BaseMonitorSchemaItems
     * @throws ApiError
     */
    public static getAppV1MonitorsCheck(): CancelablePromise<monitor_BaseMonitorSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/monitors/check',
        });
    }

    /**
     * /app/v1/monitors/<monitor_key>
     * @param monitorKey
     * @throws ApiError
     */
    public static deleteAppV1Monitors(
        monitorKey: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/app/v1/monitors/{monitor_key}',
            path: {
                'monitor_key': monitorKey,
            },
        });
    }

    /**
     * /app/v1/monitors/<monitor_key>
     * @param monitorKey
     * @param requestBody
     * @returns monitor_BaseMonitor
     * @throws ApiError
     */
    public static patchAppV1Monitors(
        monitorKey: string,
        requestBody?: monitor_MonitorPatch,
    ): CancelablePromise<monitor_BaseMonitor> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/monitors/{monitor_key}',
            path: {
                'monitor_key': monitorKey,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/monitors/<monitor_key>/check
     * @param monitorKey
     * @returns monitor_BaseMonitor
     * @throws ApiError
     */
    public static postAppV1MonitorsCheck(
        monitorKey: string,
    ): CancelablePromise<monitor_BaseMonitor> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/monitors/{monitor_key}/check',
            path: {
                'monitor_key': monitorKey,
            },
        });
    }

    /**
     * /app/v1/portfolios-benchmark
     * @returns portfolio_benchmark_PortfolioBenchmarkSchemaItems
     * @throws ApiError
     */
    public static getAppV1PortfoliosBenchmark(): CancelablePromise<portfolio_benchmark_PortfolioBenchmarkSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/portfolios-benchmark',
        });
    }

    /**
     * /app/v1/positions
     * @param acceptLanguage
     * @param accountIds
     * @param columns
     * @param grouping
     * @param includeCash
     * @returns app_v1_positions_Positions
     * @throws ApiError
     */
    public static getAppV1Positions(
        acceptLanguage?: 'en' | 'sv',
        accountIds?: string,
        columns?: string,
        grouping?: 'instrument',
        includeCash: boolean = false,
    ): CancelablePromise<app_v1_positions_Positions> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/positions',
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'account_ids': accountIds,
                'columns': columns,
                'grouping': grouping,
                'include_cash': includeCash,
            },
        });
    }

    /**
     * /app/v1/positions
     * @param acceptLanguage
     * @param accountIds
     * @param columns
     * @param grouping
     * @param includeCash
     * @param requestBody
     * @returns app_v1_positions_Position
     * @throws ApiError
     */
    public static postAppV1Positions(
        acceptLanguage?: 'en' | 'sv',
        accountIds?: string,
        columns?: string,
        grouping?: 'instrument',
        includeCash: boolean = false,
        requestBody?: app_v1_positions_PositionsCreate,
    ): CancelablePromise<app_v1_positions_Position> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/positions',
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'account_ids': accountIds,
                'columns': columns,
                'grouping': grouping,
                'include_cash': includeCash,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/positions/columns
     * @param acceptLanguage
     * @returns core_ReportColumn
     * @throws ApiError
     */
    public static getAppV1PositionsColumns(
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<core_ReportColumn> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/positions/columns',
            headers: {
                'Accept-Language': acceptLanguage,
            },
        });
    }

    /**
     * /app/v1/profit-and-loss
     * @param endDate
     * @param startDate
     * @returns profit_and_loss_ProfitAndLossReport
     * @throws ApiError
     */
    public static getAppV1ProfitAndLoss(
        endDate: string,
        startDate: string,
    ): CancelablePromise<profit_and_loss_ProfitAndLossReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/profit-and-loss',
            query: {
                'end_date': endDate,
                'start_date': startDate,
            },
        });
    }

    /**
     * /app/v1/prompt-manager/base_prompt
     * @param promptLabel
     * @param promptVersion
     * @throws ApiError
     */
    public static getAppV1PromptManagerBasePrompt(
        promptLabel?: string,
        promptVersion?: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/prompt-manager/base_prompt',
            query: {
                'prompt_label': promptLabel,
                'prompt_version': promptVersion,
            },
        });
    }

    /**
     * /app/v1/prompt-manager/base_prompt/stream
     * @param requestBody
     * @returns llm_chat_StreamResponse
     * @throws ApiError
     */
    public static patchAppV1PromptManagerBasePromptStream(
        requestBody?: app_v1_prompt_manager_OverrideBasePrompt,
    ): CancelablePromise<llm_chat_StreamResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/prompt-manager/base_prompt/stream',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/recovery/reset-password/<code>
     * @param code
     * @throws ApiError
     */
    public static getAppV1RecoveryResetPassword(
        code: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/recovery/reset-password/{code}',
            path: {
                'code': code,
            },
        });
    }

    /**
     * /app/v1/recovery/reset-password/<code>
     * @param code
     * @param requestBody
     * @throws ApiError
     */
    public static postAppV1RecoveryResetPassword(
        code: string,
        requestBody?: recovery_ResetPassword,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/recovery/reset-password/{code}',
            path: {
                'code': code,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/recovery/send-reset-code-email
     * @param requestBody
     * @throws ApiError
     */
    public static postAppV1RecoverySendResetCodeEmail(
        requestBody?: recovery_SendResetPasswordEmail,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/recovery/send-reset-code-email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/recovery/send-reset-password-email
     * @param requestBody
     * @throws ApiError
     */
    public static postAppV1RecoverySendResetPasswordEmail(
        requestBody?: recovery_SendResetPasswordEmailOrg,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/recovery/send-reset-password-email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/settings
     * @param organization
     * @returns app_v1_settings_AppSettings
     * @throws ApiError
     */
    public static getAppV1Settings(
        organization?: string,
    ): CancelablePromise<app_v1_settings_AppSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/settings',
            query: {
                'organization': organization,
            },
        });
    }

    /**
     * /app/v1/summary
     * @param endDate
     * @param startDate
     * @param acceptLanguage
     * @param accountIds
     * @returns summary_report_ClientSummary
     * @throws ApiError
     */
    public static getAppV1Summary(
        endDate: string,
        startDate: string,
        acceptLanguage?: 'en' | 'sv',
        accountIds?: string,
    ): CancelablePromise<summary_report_ClientSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/summary',
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'account_ids': accountIds,
                'end_date': endDate,
                'start_date': startDate,
            },
        });
    }

    /**
     * /app/v1/system-status/events
     * @param eventType
     * @param status
     * @returns system_status_SystemStatusEventsBodySchemaItems
     * @throws ApiError
     */
    public static getAppV1SystemStatusEvents(
        eventType?: 'incident' | 'planned_maintenance',
        status?: 'scheduled' | 'ongoing' | 'completed',
    ): CancelablePromise<system_status_SystemStatusEventsBodySchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/system-status/events',
            query: {
                'event_type': eventType,
                'status': status,
            },
        });
    }

    /**
     * /app/v1/user-goals
     * @returns user_goal_UserGoalSchemaItems
     * @throws ApiError
     */
    public static getAppV1UserGoals(): CancelablePromise<user_goal_UserGoalSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/user-goals',
        });
    }

    /**
     * /app/v1/user-goals
     * @param requestBody
     * @returns user_goal_UserGoal
     * @throws ApiError
     */
    public static postAppV1UserGoals(
        requestBody?: user_goal_UserGoalCreate,
    ): CancelablePromise<user_goal_UserGoal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/user-goals',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/user-goals/<user_goal_id>
     * @param userGoalId
     * @throws ApiError
     */
    public static deleteAppV1UserGoals(
        userGoalId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/app/v1/user-goals/{user_goal_id}',
            path: {
                'user_goal_id': userGoalId,
            },
        });
    }

    /**
     * /app/v1/user-goals/<user_goal_id>
     * @param userGoalId
     * @returns user_goal_UserGoal
     * @throws ApiError
     */
    public static getAppV1UserGoals1(
        userGoalId: string,
    ): CancelablePromise<user_goal_UserGoal> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/user-goals/{user_goal_id}',
            path: {
                'user_goal_id': userGoalId,
            },
        });
    }

    /**
     * /app/v1/user-goals/<user_goal_id>
     * @param userGoalId
     * @param requestBody
     * @returns user_goal_UserGoal
     * @throws ApiError
     */
    public static patchAppV1UserGoals(
        userGoalId: string,
        requestBody?: user_goal_UserGoalUpdate,
    ): CancelablePromise<user_goal_UserGoal> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/user-goals/{user_goal_id}',
            path: {
                'user_goal_id': userGoalId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/user-goals/<user_goal_id>
     * @param userGoalId
     * @param requestBody
     * @returns user_goal_UserGoal
     * @throws ApiError
     */
    public static putAppV1UserGoals(
        userGoalId: string,
        requestBody?: user_goal_UserGoalUpdate,
    ): CancelablePromise<user_goal_UserGoal> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/app/v1/user-goals/{user_goal_id}',
            path: {
                'user_goal_id': userGoalId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/user-goals/<user_goal_id>/complete
     * @param userGoalId
     * @returns user_goal_UserGoal
     * @throws ApiError
     */
    public static postAppV1UserGoalsComplete(
        userGoalId: string,
    ): CancelablePromise<user_goal_UserGoal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/user-goals/{user_goal_id}/complete',
            path: {
                'user_goal_id': userGoalId,
            },
        });
    }

    /**
     * /app/v1/user-goals/<user_goal_id>/performance
     * @param userGoalId
     * @returns market_value_MarketValueHistoryReport
     * @throws ApiError
     */
    public static getAppV1UserGoalsPerformance(
        userGoalId: string,
    ): CancelablePromise<market_value_MarketValueHistoryReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/user-goals/{user_goal_id}/performance',
            path: {
                'user_goal_id': userGoalId,
            },
        });
    }

    /**
     * /app/v1/user-goals/<user_goal_id>/uncomplete
     * @param userGoalId
     * @returns user_goal_UserGoal
     * @throws ApiError
     */
    public static postAppV1UserGoalsUncomplete(
        userGoalId: string,
    ): CancelablePromise<user_goal_UserGoal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/app/v1/user-goals/{user_goal_id}/uncomplete',
            path: {
                'user_goal_id': userGoalId,
            },
        });
    }

    /**
     * /app/v1/user-settings
     * @returns app_v1_settings_UserSettings
     * @throws ApiError
     */
    public static getAppV1UserSettings(): CancelablePromise<app_v1_settings_UserSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/v1/user-settings',
        });
    }

    /**
     * /app/v1/user-settings
     * @param requestBody
     * @returns app_v1_settings_UserSettings
     * @throws ApiError
     */
    public static patchAppV1UserSettings(
        requestBody?: app_v1_settings_UserSettings,
    ): CancelablePromise<app_v1_settings_UserSettings> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/app/v1/user-settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * /app/v1/user-settings
     * @param requestBody
     * @returns app_v1_settings_UserSettings
     * @throws ApiError
     */
    public static putAppV1UserSettings(
        requestBody?: app_v1_settings_UserSettings,
    ): CancelablePromise<app_v1_settings_UserSettings> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/app/v1/user-settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
